import React, { ReactElement } from 'react'

import { Trans } from '@lingui/macro'

import { Text } from '../../../../styled'

export function TauroRestrictedJurisdictions(): ReactElement {
  return (
    <Text textAlign="left">
      <Trans>
        We do not establish accounts to residents of certain jurisdictions including Belgium, Democratic Republic of
        Congo, Eritrea, Iran, Democratic People’s Republic of Korea, Libyan Arab Jamahiriya, Somalia, Sudan, Israel,
        United States (and US reportable persons) or any particular country or jurisdiction where such distribution or
        use would be contrary to local law or regulation.
      </Trans>
    </Text>
  )
}
